import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getVariantGeneralInfo,
  getVariantType,
  getIsFLT3ITD,
} from "../../../../state/selectors/CardsUI.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import Hgvs from "../../../../pages/variant/components/Hgvs/Hgvs";
import ProteinValue from "../../../../pages/variant/components/ProteinValue/ProteinValue";

const VariantDetailsCard = ({
  card,
  variantGeneralInfo,
  variantType,
  isFLT3ITD,
}) => {
  const calcSecondaryTitle = () => {
    if (!variantType) return "";
    if (isFLT3ITD) return <b>ITD</b>;
    return <b>{variantType}</b>;
  };

  return (
    <CardWrapper
      {...card}
      secondaryTitle={calcSecondaryTitle()}
      isDisabled={false}
      wizardId="generalInfoCard"
    >
      {variantGeneralInfo ? (
        <div className="tw-font-bold">
          {variantGeneralInfo?.hgvsCdot ? (
            <div data-testid="variant-card-hgvsdot">
              <Hgvs isFLT3ITD={isFLT3ITD} hgvs={variantGeneralInfo?.hgvsCdot} />
            </div>
          ) : null}
          {variantGeneralInfo?.pValue ? (
            <div data-testid="variant-card-pvalue">
              <ProteinValue
                isFLT3ITD={isFLT3ITD}
                pValue={variantGeneralInfo?.pValue}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </CardWrapper>
  );
};

VariantDetailsCard.propTypes = {
  variantGeneralInfo: PropTypes.shape({
    hgvsCdot: PropTypes.string,
    pValue: PropTypes.string,
  }).isRequired,
  variantType: PropTypes.string,
  isFLT3ITD: PropTypes.bool,
  card: PropTypes.instanceOf(Card),
};

VariantDetailsCard.defaultProps = {
  variantType: null,
  isFLT3ITD: false,
  card: null,
};

const mapStateToProps = (state) => ({
  variantGeneralInfo: getVariantGeneralInfo(state),
  variantType: getVariantType(state),
  isFLT3ITD: getIsFLT3ITD(state),
});

export default connect(mapStateToProps)(VariantDetailsCard);
